import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { loginUrl } from '#/api/client'

const loginSearchSchema = z.object({
  return_to: z.string().optional(),
})

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  component: LoginRoute,
})

function LoginRoute() {
  const { return_to } = Route.useSearch()
  const { t } = useTranslation()

  useEffect(() => {
    window.location.href = loginUrl(return_to ?? '/')
  }, [return_to])

  return (
    <main className="flex min-h-svh items-center justify-center text-muted-foreground">
      {t('auth.redirecting')}
    </main>
  )
}
